export default "__VITE_ASSET__50473400__"